import styled from "styled-components";
export const CarWrapper = styled.div`
  background-color: #fff;
`;
